module.exports = __webpack_public_path__ + "img/ci-wavveon-142-x-24.ba6892fe.svg";